<template>
  <div class="auth-page">
    <v-container class="auth-container">
      <v-card class="auth-card">
        <v-card-title class="text-center text-primary text-h5 font-weight-bold">
          Forgot Password
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form v-if="!sent" @submit.once.prevent="submit">
            <v-text-field
              v-model="email"
              label="Your email"
              outlined
              required
            />
            <v-btn type="submit" color="primary" block class="mt-3" :loading="loading" :disabled="loading || sent">
              Send Reset Link
            </v-btn>
          </v-form>
          <v-alert v-if="sent" type="success" dense class="mt-3">
            If that address exists, you’ll receive a reset link shortly.
          </v-alert>
          <v-alert v-if="error" type="error" dense class="mt-3">
            {{ error }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      loading: false,
      sent: false,
      error: '',
    };
  },
  methods: {
    async submit() {
      // Prevent duplicate submissions
      if (this.loading || this.sent) return;

      this.error = '';
      this.loading = true;
      try {
        await axios.post('/api/auth/password/reset/', { email: this.email });
        this.sent = true;
      } catch (e) {
        if (e.response && e.response.status === 429) {
          const retryAfter = parseInt(e.response.headers['retry-after'] || '0', 10);
          const minutes = Math.ceil(retryAfter / 60) || 1;
          this.error = `Too many attempts. Please try again in ${minutes} minute(s).`;
        } else {
          this.error = 'Unable to send reset link. Please try again.';
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Full Background Gradient */
.auth-page {
  background: linear-gradient(to bottom, #fafafa, #e7effa, #d2e3f5);
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 8vh;
  overflow: hidden;
}

/* Centered Container */
.auth-container {
  width: 100%;
  max-width: 450px;
}

/* Card Styling */
.auth-card {
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;
  width: 100%;
}
.auth-card:hover {
  transform: translateY(-5px);
}
</style>